import React from "react";

// STYLED COMPONENTS
import { Main } from "./styles";

export default function Spinner({ speed = 1.1, color = "#444", size = 20 }) {
    return <Main id="spinner" speed={speed} color={color} size={size} />;
}